<template>
  <generic-update-list
    v-bind="{ model, modelHeaders, modelFk, defaultItem }"
    custom-export-url="/concert-categories/export/"
  >
    <template v-slot:form="{ editedItem, error }">
      <v-row>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="editedItem.name"
            label="Nome"
            :error-messages="error.name"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
  </generic-update-list>
</template>

<script>
import models from "@/models"

export default {
  data() {
    return {
      modelHeaders: [{ text: "Nome", value: "name" }],
      model: models.ConcertCategory,
    }
  },
  computed: {
    modelFk() {
      return { show: this.$route.params.id }
    },
  },
  methods: {
    defaultItem: () => ({
      name: "",
    }),
  },
}
</script>
